// Action types
export const UPDATE_TRIAGE_ITEMS = 'triage-pane/UPDATE_TRIAGE_ITEMS';
export const SET_TRIAGE_USERS = 'triage-pane/SET_TRIAGE_USERS';
export const SET_OPTION_MENU_OPEN = 'triage-pane/SET_OPTION_MENU_OPEN';
